// import moment from "moment";
import TableActions from "./components/tableActions";
export type TMembersProps = {};

export const CalendarTypeOption = [
  { label: "Monthly", value: "month" },
  { label: "Quarterly", value: "quarter" },
  { label: "Yearly", value: "year" },
];

export const viewTypeOptions = [
  { label: <i className="icon-list" />, value: "tableView" },
  { label: <i className="icon-grid" />, value: "cardView" },
];

export const registryDropdownMap = new Map();

registryDropdownMap.set("Millennium", [
  "filtered_members",
  "all_members",
  "members_admit_in_hospital",
  "member_admitted",
  "recently_discharged",
  "emergency_admitted",
  "high_risk",
  "frequent_flyer",
  "last_viewed_members",
]);

export const memberType = [
  { label: "Filtered Members", value: "filtered_members", key: "isFiltered" },
  { label: "Assigned Members", value: "all_members", key: "" },
  { label: "Inpatients", value: "members_admit_in_hospital", key: "isInpatient" },
  { label: "Admissions", value: "member_admitted", key: "isAdmitted" },
  { label: "Discharges", value: "recently_discharged", key: "isDischarged" },
  { label: "ER", value: "emergency_admitted", key: "isEmergency" },
  // { label: "Caseload", value: "case_load", key: "isCaseLoad" },
  // { label: "End Of Life Patients", value: "eol_indicator", key: "eol_indicator" },
  { label: "High Risk Patients", value: "high_risk", key: "high_risk" },
  { label: "High Intensity Patients", value: "high_intensity", key: "high_intensity" },
  { label: "Frequent Flyer", value: "frequent_flyer", key: "frequent_flyer" },
  { label: "Dialysis Patients", value: "dialysis", key: "dialysis" },
  { label: "Cancer Patients", value: "cancer", key: "cancer" },
  { label: "HIV Patients", value: "hiv", key: "hiv" },
  { label: "Last Viewed Members", value: "last_viewed_members", key: "last_viewed_members" },
]

export const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Action",
    dataIndex: "action",
    width: 200,
    render: (age: any, record: any) => {
      return <TableActions data={record} />;
    },
  },
  {
    title: "Address",
    dataIndex: "address",
    filters: [
      {
        text: "London",
        value: "London",
      },
      {
        text: "New York",
        value: "New York",
      },
    ],
    onFilter: (value: any, record: any) => record.address.indexOf(value) === 0,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
    render: () => <span>Delete</span>,
  },
];

export interface IMembers {
  key: React.Key;
  priority: number;
  action: string;
  caremgr_name: string;
  client_id: string;
  program: string;
  patient_case_status: string;
  patient_status: string;
  case_last_action_date: string;
  pcp_name: string;
  admissions_risk: string;
  last_year_cost: string;
  admissions_risk_flag: string;
  patient_name?: string;
  patient_id?: string;
  reminders?: [];
  notes?: [];
  prev_caremgr_name: string;
  prev_case_status: string;
  caremgr_profile: string;
  alerts?: [];
  patient_hopital_discharge_flag?: any;
  patient_hopital_admission_flag?: any;
  patient_frequent_flyer_status?: any;
  year_month?: any;
  risk_category_flag: string;
  risk_category: any;
  member_caseload_status: string;
  patient_eol_status: string;
  cadence_status?: string;
  cadence_id?: number;
}

// let isSearchEnable: boolean = true;

// export const memberTableColumns = [
//   {
//     title: "PRIORITY",
//     dataIndex: "priority",
//     sorter: (a: any, b: any) => a.priority - b.priority,
//   },
//   {
//     title: (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         {isSearchEnable ? (
//           <>
//             <Input
//               placeholder="Search"
//               className="memberTableSearch"
//               style={{ width: 240 }}
//               prefix={<span className="icon-search" />}
//               onChange={() => {}}
//               onPressEnter={() => {}}
//             />
//           </>
//         ) : (
//           <>
//             <span>MEMBER</span>
//             <i
//               className="icon icon-search"
//               onClick={() => (isSearchEnable = !isSearchEnable)}
//             ></i>
//           </>
//         )}
//       </div>
//     ),

//     dataIndex: "member",
//     sorter: (a: any, b: any) => a.member.length - b.member.length,
//   },
//   {
//     title: (
//       <Menu className="action-menu" mode="horizontal">
//         <SubMenu className="action-sub-menu" key="SubMenu" title="ACTION">
//           <Menu.Item key="1">Maximum updates first</Menu.Item>
//           <Menu.Item key="2">New alerts first</Menu.Item>
//           <Menu.Item key="3">Maximum alerts first</Menu.Item>
//           <Menu.Item key="4">Upcoming reminders first</Menu.Item>
//           <Menu.Item key="5">Maximum reminders first</Menu.Item>
//         </SubMenu>
//       </Menu>
//     ),
//     dataIndex: "action",

//     // FIXME: condition needs to be update
//     render: (text: any) => (
//       <>
//         {text === "clipboard" ? (
//           <i className="icon icon-clipboard" onClick={() => {}}></i>
//         ) : text === "action" ? (
//           <i className="icon icon-alert-triangle" onClick={() => {}}></i>
//         ) : (
//           <i className="icon icon-calendar" onClick={() => {}}></i>
//         )}
//       </>
//     ),
//   },
//   {
//     title: "CM ASSIGNED",
//     dataIndex: "cmAssigned",
//   },
//   {
//     title: "CLIENT ID",
//     dataIndex: "clientId",
//   },

//   {
//     title: "PROGRAM",
//     dataIndex: "program",
//   },

//   {
//     title: "CASE STATUS",
//     children: [
//       {
//         title: "STATUS",
//         dataIndex: "status",
//         key: "status",
//         render: (text: any) => (
//           <>
//             {text === "Open" ? (
//               <span className="f14 w500 clr-e100">{text}</span>
//             ) : text === "Reviewed" ? (
//               <span className="f14 w500 clr-themeColor">{text}</span>
//             ) : text === "On Hold" ? (
//               <span className="f14 w500 clr-themeColor">{text}</span>
//             ) : (
//               <span className="f14 w500 clr-s100">{text}</span>
//             )}
//           </>
//         ),
//       },
//       {
//         title: "LAST ACTION DATE",
//         dataIndex: "lastActionDate",
//         key: "lastActionDate",
//         sorter: (a: any, b: any) => a.lastActionDate - b.lastActionDate,
//       },
//       {
//         title: "Previous CM",
//         dataIndex: "previousCm",
//         key: "previousCm",
//       },
//     ],
//   },
//   {
//     title: "PCP NAME",
//     dataIndex: "pcpName",
//   },

//   {
//     title: "ADMISSION",
//     dataIndex: "admissionRisk",
//   },
// ];

export const layerViews = [
  {
    label: "Filters:",
    key: "filter",
    width: "300",
    padding: 0,
    className: "filtersDrawer",
  },
  {
    label: "Select column to display",
    key: "columnConfig",
    width: "580",
    padding: 16,
    className: "tableConfigDrawer",
  },
];

export const tableCardData = [
  {
    name: "Ashley John",
    code: "HUY234567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY234568",
    status: "open",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY234569",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY334567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY434567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY534567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY634567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY734567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY834567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY934567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY244567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
  {
    name: "Ashley John",
    code: "HUY254567",
    status: "reviewed",
    program: "Program 1",
    hccrisk: "9.32",
    up: "0.2",
    pcp: "Alice Dose MD",
    cost: "40000",
  },
];

export const caseDistrubution: Array<any> = [
  {
    status: "closed",
    label: "Closed",
    count: 0,
  },
  {
    status: "active",
    label: "Active",
    count: 0,
  },
  {
    status: "new",
    label: "New",
    count: 0,
  },
  {
    status: "followup",
    label: "Follow Up",
    count: 0,
  },
];

export const notes = [
  {
    notesId: 1,
    notes: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore",
    isBookMarked: true,
    notesCreateDate: "01-12-2021 00:00:00",
  },
  {
    notesId: 2,
    notes: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore",
    isBookMarked: false,
    notesCreateDate: "01-12-2021 00:00:00",
  },
  {
    notesId: 3,
    notes: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore",
    isBookMarked: true,
    notesCreateDate: "01-12-2021 00:00:00",
  },
  {
    notesId: 4,
    notes: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore",
    isBookMarked: false,
    notesCreateDate: "01-12-2021 00:00:00",
  },
];

export const reminders = [
  {
    id: 1,
    content: "Hello note 1",
    isMarked: true,
  },
  {
    id: 1,
    content: "Hello note 2",
    isMarked: false,
  },
];

export const alerts = [
  {
    id: 1,
    content: "Ashley has fallen , BP increased 140/90mmHg.",
    isMarked: true,
    date: "28th Oct",
    time: "09:17 am",
  },
  {
    id: 2,
    content: "Ashley has fallen , BP increased 120/90mmHg.",
    isMarked: false,
    date: "28th Oct",
    time: "09:17 am",
  },
  {
    id: 3,
    content: "Ashley has fallen , BP increased 140/90mmHg.",
    isMarked: true,
    date: "28th Oct",
    time: "09:17 am",
  },
  {
    id: 4,
    content: "Ashley has fallen , BP increased 120/90mmHg.",
    isMarked: false,
    date: "28th Oct",
    time: "09:17 am",
  },
];

export const allReminders = [
  {
    reminderId: 1640629900,
    reminderStartDate: "01-01-2022 00:00:00",
    reminderEndDate: "02-03-2022 00:00:00",
    reminder: "Follow-Up for the dialysis with senior Doctor 28 1",
  },
  {
    reminderId: 1640629999,
    reminderStartDate: "01-01-2022 00:00:00",
    reminderEndDate: "02-03-2022 00:00:00",
    reminder: "Follow-Up for the dialysis with senior Doctor 28 2",
  },
  {
    reminderId: 1640802700,
    reminderStartDate: "01-01-2022 00:00:00",
    reminderEndDate: "02-03-2022 00:00:00",
    reminder: "Follow-Up for the dialysis with senior Doctor 30 1",
  },
  {
    reminderId: 1640802900,
    reminderStartDate: "01-01-2022 00:00:00",
    reminderEndDate: "02-03-2022 00:00:00",
    reminder: "Follow-Up for the dialysis with senior Doctor 30 2",
  },
];
// export const headersForDownloadRecord:any = {
//   patientName : "Patient Name",
//   patientId   : "Patient ID",
//   age : "Age",
//   gender: "Gender",
//   clientId:"Client ID",
//   PCPName:"PCP Name",
//   priority:"Priority",
//   program:"Program",
//   admissionsRiskScore:"Admissions Risk Score",
//   admissionsRiskFlag:"Admissions Risk Flag",
//   careManagerName:"Care Manager Name",
//   prevCareManagerName:"Prev Care Manager Name",
//   patientStatus:"Patient Status",
//   previousCaseStatus:"Previous Case Status",
//   caseLastActionDate:"Case Last Action Date",
//   isHospitalAdmitted:"Is Hospital Admitted",
//   isDischarged:"Is Discharged",
//   hospitalEventDate:"Hospital Event Date",
//   officeName:"Office Name",
//   currentPeriodHospitalAdmissions:"Current Period Hospital Admissions",
//   currentPeriodReAdmissions:"Current Period RE-Admissions",
//   currentPeriodErAdmissions:"Current Period ER-Admissions",
//   currentPeriodErVisits:"Current Period ER-Visits",
//   currentPeriodOfficeVisits:"Current Period Office Visits",
//   lastYearCost:"Last Year Cost",
//   hccRisk:"HCC Risk",
//   riskCategory:"Risk Category",
//   admissionDate:"Admission Date",
//   dischargeDate:"Discharge Date"
// };

export const adtdropdownmap = new Map();
adtdropdownmap.set("isInpatient", "isInpatient");
adtdropdownmap.set("isDischarged", "isDischarged");
adtdropdownmap.set("isAdmitted", "isAdmitted");
adtdropdownmap.set("isEmergency", "isEmergency");
adtdropdownmap.set("isCaseLoad", "member_caseload_status");
adtdropdownmap.set("eol_indicator", "patient_eol_status");
adtdropdownmap.set("high_risk", "patient_hrp_status");
adtdropdownmap.set("high_intensity", "patient_hip_status");
adtdropdownmap.set("dialysis", "patient_dylpat_status");
adtdropdownmap.set("cancer", "patient_canpat_status");
adtdropdownmap.set("hiv", "patient_hivpat_status");
adtdropdownmap.set("frequent_flyer", "patient_frequent_flyer_status");
adtdropdownmap.set("last_viewed_members", "last_viewed_members");

export const columnLayoutLabelMap = new Map([
  ['Millennium', {
    member_admitted : 'Admissions',
    recently_discharged : 'Discharges',
    emergency_admitted : 'ER',
  }],
  ['Default', {
    case_load: 'Caseload',
    eol_indicator: 'End Of Life Patients',
    high_intensity: 'High Intensity Patients',
    member_admitted: 'Admissions',
    recently_discharged: 'Discharges',
    emergency_admitted: 'ER',
    members_admit_in_hospital: 'Inpatients'
  }]
]);

export const adtDropdownPageMap = new Map([
  ['Millennium', {
    isAdmitted : 'Member List-Hospitalization',
    isDischarged : 'Member List-Hospitalization',
    isEmergency : 'Member List-ER',
    reset_all: 'Member List-Reset All'
  }],
  ['Default', {
    isCaseLoad: 'Member List-Caseload',
    eol_indicator: 'Member List-End Of Life Patients',
    // high_intensity: 'Member List-High Intensity Care',
    reset_all: 'Member List-Reset All',
    isAdmitted: 'Member List-Hospitalization',
    isDischarged: 'Member List-Hospitalization',
    isEmergency: 'Member List-ER',
    isInpatient: 'Member List-Hospitalization'
  }]
]);

export const filterApiKeyMap = new Map();

filterApiKeyMap.set("office_name", "OfficeNameLst");

export const checkBoxObj: any = {
  CASELOAD: "member_caseload_status",
  EOL: "patient_eol_status",
  HIGHRISK: "patient_hrp_status",
  CATCARE: "patient_ccp_status",
  DIALYSIS: "patient_dylpat_status",
  CANCER: "patient_canpat_status",
  HIV: "patient_hivpat_status",
  FLYER: "patient_frequent_flyer_status",
  HIGHINTENSITY:'patient_hip_status'
};

export const mappingOfProgramsAndRegistry: any = {
  HIGHRISK: "HRP",
};


export const caseStatusChangePayload : any = {
  'memberprofileHeaderRadio' : {"actionModule" : "member-details","actionTab" : "member-profile-header","actionLocation" : "right-action-bar","actionDescription" : "status_change"} 
}